module.exports = __webpack_public_path__ + "static/img/anxun21new.7261cbab.png";